<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M10.75 16.44H6.31m8.6-8.88h-8.6M17.42 12h-8.56M1.88 16.67V7.33c0-1.87 0-2.8.36-3.51a3.33 3.33 0 0 1 1.46-1.46C4.41 2 5.34 2 7.21 2h9.34c1.87 0 2.8 0 3.51.36.63.32 1.14.83 1.46 1.46.36.71.36 1.64.36 3.51v9.34c0 1.87 0 2.8-.36 3.51a3.33 3.33 0 0 1-1.46 1.46c-.71.36-1.64.36-3.51.36H7.21c-1.87 0-2.8 0-3.51-.36a3.33 3.33 0 0 1-1.46-1.46c-.36-.71-.36-1.64-.36-3.51Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
